
import useAxiosPrivate from "./useAxiosPrivate";
import { useDispatch } from "react-redux";
import {assigngetPincodeDetails}from "../slice/adminMapSlice"

const usePincodeData = () => {
  const Axios = useAxiosPrivate();
  const dispatch = useDispatch();

  const getAssignPincode = async (param) => {

    try {
      const response = await Axios.post("get_boundary_data", param);
      const data = response.data;
      
      dispatch(assigngetPincodeDetails(data));
      return data;  
    } catch (error) {
      console.error("Error fetching admin map data:", error);
      throw error;  
    }
  };
  return getAssignPincode;
};

export default usePincodeData;

